import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    margin: '10px 0px 20px 0px'
  },
  toolbarLeft: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2)
  },
  toolbarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  select: {
    minWidth: 200,
    height: 42,
    background: theme.palette.common.white
  },
  statusFilters: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    height: 42,
    padding: 4,
    background: theme.palette.common.white,
    border: '1px solid #eeeeee',
    borderRadius: theme.spacing()
  },
  statusChip: {
    height: 32,
    border: 0,
    borderRadius: theme.spacing(),
    padding: '0 12px',
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: '#606a75',
    '&.Mui-selected': {
      background: theme.palette.badge.info.bg,
      color: theme.palette.badge.info.text
    },
    '&.Mui-selected:hover': {
      background: theme.palette.badge.info.bg
    }
  },
  buttons: {
    height: 44,
    letterSpacing: 1.25,
    fontSize: 16,
    fontWeight: '400',
    minWidth: 'unset',
    padding: '0 24px'
  },
  outlined: {
    background: theme.palette.common.white,
    fontWeight: '500',
    '&:hover': {
      background: theme.palette.common.white,
      opacity: 0.8
    },
    '&:focus': {
      background: theme.palette.common.white,
      opacity: 0.8
    }
  },
  icon: {
    fill: theme.palette.primary.main
  }
}));
